// COMPONENTS
import Card from "../app/Card";
import { AgentSearchProps } from "./agent-search";
import Rating from "../app/Rating";
// IMAGES
import driverProfile from "../../assets/driver-profile.png";
import car from "../../assets/car.png";
import call from "../../assets/call.png";

export default function DriverOngoing({ resetStep }: AgentSearchProps) {
  return (
    <div>
      <Card header="Gabin is on the way to deliver your item">
        <div className="space-y-10">
          <div>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <img src={driverProfile} alt="" className="w-16" />
                <div>
                  <h1 className="text-lg text-themeText font-semibold">
                    Gabin Yarigo
                  </h1>
                  <Rating />
                </div>
              </div>
              <div className="bg-accent rounded-md py-[6px] px-4">
                <h1 className="text-center font-semibold text-lg text-themeText">
                  Ongoing
                </h1>
              </div>
            </div>
            <div className="flex items-center justify-between my-8">
              <div className="flex items-center space-x-4">
                <img src={car} alt="" className="w-16" />
                <div>
                  <h1 className="text-lg text-themeText font-semibold">
                    Toyota, Corolla black
                  </h1>
                  <p className="font-semibold text-paragraph">121-GFW-AAA</p>
                </div>
              </div>
              <div className="bg-border/20 p-3 rounded-full">
                <img src={call} alt="" className="w-[22.5px] h-[22.5px]" />
              </div>
            </div>
            <div>
              <div className="flex items-center justify-between mb-3 font-medium text-themeText">
                <h1>Locations</h1>
                <h1>Drop off by 2:12pm</h1>
              </div>
              <div className="flex space-x-2 ">
                <div className="text-center my-3">
                  <h1>From</h1>
                  <div className="h-5 bg-themeText w-[2px] mx-auto"></div>
                  <h1>To</h1>
                </div>
                <div className="bg-border p-3 bg-opacity-[0.15] rounded-lg w-full">
                  <h1 className="text-paragraph font-medium my-2">
                    Shomolu Lagos
                  </h1>
                  <div className="relative mt-1">
                    <h1 className="my-2 text-paragraph font-medium">
                      Bola Kemi, Lagos Nigeria
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="mt-3">
              <h1 className="font-medium text-themeGray flex items-center">
                Amount:{" "}
                <h2 className="font-semibold text-2xl text-themeText ml-2">
                  NGN 1,200
                </h2>
              </h1>
            </div> */}
          </div>
        </div>
      </Card>
    </div>
  );
}
